import React, { Component } from 'react';
import ScrollLock from 'react-scrolllock';
import YouTubeModal from './youtube-modal';

export const YTModalContext = React.createContext();

export default function withYouTubeModal(ModalChild) {

  return class ModalWrapped extends Component {

    static getInitialProps(ctx) {
      if (ModalChild.getInitialProps) {
        return ModalChild.getInitialProps(ctx);
      }
    }

    state = {
      modal: false,
    };

    getId = (url) => {
      if (!url) { return null; }

      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);

      return (match && match[7].length === 11) ? match[7] : false;
    };

    toggleModal = (e, url = false) => {
      e.preventDefault();

      if (!url) {
        this.setState({ modal: null });
        return;
      }

      const id = this.getId(url);

      this.setState(prevState => ({
        modal: !prevState.id === id ? null : id,
      }));
    }

    render() {
      return (
        <YTModalContext.Provider
          value={{
            modal: this.state.modal,
            toggleModal: this.toggleModal,
          }}
        >

          <ModalChild {...this.props} />

          <YouTubeModal
            id={this.state.modal}
            isOpen={!!this.state.modal}
            onRequestClose={this.toggleModal}
          />

          <ScrollLock isActive={!!this.state.modal} />

        </YTModalContext.Provider>
      );
    }
  };
}
